;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["propsdata"],
  data: function data() {
    return {
      customer_name: null,
      customer_phone: null,
      modal_name: "customerServiceInvoiceModal",
      modal_target: "#customerServiceInvoiceModal",
      merchant_id: null,
      service_id: null,
      service_name: null,
      consumer_secret: null,
      consumer_key: null,
      api_token: null,
      service_cost: 0,
      margin: 0,
      total_cost: 0,
      selectedService: null,
      availableServices: this.propsdata,
      user_id: null,
      parent_account: null,
      notification_url: null
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.consumer_secret = this.$attrs["con_secret"];
    this.consumer_key = this.$attrs["con_key"];
    $(this.modal_target).on("hidden.bs.modal", function () {
      _this.reset();
    });
  },
  created: function created() {
    this.notification_url = this.$attrs["notification_url"];
    this.availableServices = this.$attrs["services"];
    this.merchant_id = this.$attrs["merchant_id"];
    this.parent_account = this.$attrs["account_id"];
    this.customer_id = this.$attrs["customer_id"];
    this.user_id = this.$attrs["user_id"];
    this.customer_name = this.$attrs["customer_name"];
    this.customer_phone = this.$attrs["customer_phone"];
    this.modal_name = this.modal_name + "_" + this.customer_id;
    this.modal_target = this.modal_target + "_" + this.customer_id;
  },
  methods: {
    authAndcreateInvoice: function authAndcreateInvoice() {
      var _this2 = this;

      if (this.selectedService == null) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please select a service !"
        });
        return;
      }
      var url = "/api/oauth/generate/token";
      var payload = {
        secret: this.consumer_secret,
        key: this.consumer_key
      };
      Vue.axios.post(url, payload).then(function (response) {
        _this2.createInvoice(response.data.token);
      }).catch(function (error) {}).then(function () {});
    },
    loadMyServices: function loadMyServices() {
      var _this3 = this;

      var url = "/api/service/?merchant_id=" + this.merchant_id;
      var api_headers = { Authorization: "Bearer " + this.api_token };
      Vue.axios.get(url, {
        headers: api_headers
      }).then(function (response) {
        _this3.availableServices = response.data.services;
      }).catch(function (error) {}).then(function () {});
    },
    refreshTotalCost: function refreshTotalCost() {
      this.total_cost = parseFloat(this.margin) + parseFloat(this.service_cost);
    },
    refreshCosts: function refreshCosts() {
      if (this.selectedService != null) {
        this.margin = this.selectedService.commission;
      }
      this.total_cost = parseFloat(this.margin) + parseFloat(this.service_cost);
    },
    createInvoice: function createInvoice(token) {
      var _this4 = this;

      var urlIs = "/api/invoice/create";
      var uniq_ref = this.generateUUID();
      var api_headers = { Authorization: "Bearer " + token };
      var api_params = {
        client_invoice_ref: uniq_ref,
        amount_expected: this.total_cost,
        msisdn: this.customer_phone,
        amount_settled_offline: 0,
        service_id: this.selectedService.id,
        merchant_id: this.merchant_id,
        owner_type: "merchant",
        items: [{
          price: this.total_cost,
          item_ref: uniq_ref,
          quantity: 1,
          desc: "Invoice for service - " + this.selectedService.name,
          require_settlement: true,
          settlements: [{
            id: uniq_ref,
            desc: "Settlement for service - " + this.selectedService.name,
            value: this.total_cost,
            account_number: this.parent_account
          }]
        }],
        account_id: this.parent_account,
        currency: this.selectedService.currency.symbol,
        notification_url: this.notification_url
      };
      Vue.axios.post(urlIs, api_params, {
        headers: api_headers
      }).then(function (response) {
        if (response.data.status == 422) {
          _sweetalert2.default.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went horribly wrong !"
          });
        } else {
          $(_this4.modal_target + " .close").click();
          _sweetalert2.default.fire({
            position: "top-end",
            icon: "success",
            title: "Invoice has been created.",
            showConfirmButton: false,
            timer: 4000
          });
        }
      }).catch(function (error) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!"
        });
      }).then(function () {});
    },
    reset: function reset() {
      this.margin = 0;
      this.total_cost = 0;
      this.selectedService = null;
    },
    generateUUID: function generateUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    },
    generateInvoiceNo: function generateInvoiceNo() {
      var length = 6;
      var result = "";
      var characters = "ABCDEFGHIJKLMNPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result.toUpperCase();
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"btn btn-sm btn-primary lift",attrs:{"href":"#","data-toggle":"modal","data-target":_vm.modal_target}},[_vm._v("Invoice Customer")]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":_vm.modal_name,"tabindex":"-1","role":"dialog","aria-labelledby":_vm.modal_name,"aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('form',{attrs:{"onsubmit":"return false;"}},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Invoice Customer - "+_vm._s(_vm.customer_name))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"overflow":"auto"}},[_c('div',{staticClass:"md-form mb-5"},[_c('label',{attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Service Provided")]),_vm._v(" "),_c('v-select',{attrs:{"label":"name","options":_vm.availableServices,"reduce":function (name) { return name.id; }},on:{"change":_vm.refreshCosts},model:{value:(_vm.selectedService),callback:function ($$v) {_vm.selectedService=$$v},expression:"selectedService"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Service Margin")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.margin),expression:"margin"}],staticClass:"form-control",attrs:{"type":"number","min":"0","readonly":""},domProps:{"value":(_vm.margin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.margin=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Service Cost")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.service_cost),expression:"service_cost"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.service_cost)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.service_cost=$event.target.value},_vm.refreshTotalCost]}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Total Chargeable Cost")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.total_cost),expression:"total_cost"}],staticClass:"form-control",attrs:{"type":"number","min":"0","readonly":""},domProps:{"value":(_vm.total_cost)},on:{"input":function($event){if($event.target.composing){ return; }_vm.total_cost=$event.target.value}}})],1)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("Close")]),_vm._v(" "),_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Create Invoice"},on:{"click":_vm.authAndcreateInvoice}})])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f8cbbc64", __vue__options__)
  } else {
    hotAPI.reload("data-v-f8cbbc64", __vue__options__)
  }
})()}